/**
 * Narwhalia backend
 * Swagger API docs for Narwhalia Backend application
 *
 * OpenAPI spec version: 0.9
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export class LoginMetaMaskDto {
	constructor(
	/** 0x[0-9A-Fa-f]{40} */
	public address: string,
	/** 0x[0-9A-Fa-f]{130} */
	public signature: string){}
}